import Link from "next/link";
import { Button } from "antd";

const STYLE_OUTER = {
  textAlign: "center",
  fontSize: "24px",
  color: "#4A4A4A",
  height: "100vh",
  paddingTop: "calc((100vh - 400px) / 2)",
};

const STYLE_MT20 = {
  marginTop: "20px",
};

const Page = (props) => {
  const { statusCode, post } = props;

  const page404 = (
    <div>
      <img src="/static/error-404.svg" alt="404" />
      <p style={STYLE_MT20}>对不起，什么也没有找到</p>
      <p>
        <Link href="/">
          <Button>返回首页</Button>
        </Link>
      </p>
    </div>
  );

  const page500 = (
    <div>
      <img src="/static/error-500.svg" alt="500" />
      <p style={STYLE_MT20}>服务器开小差了，稍后再试吧</p>
    </div>
  );

  const pageDeleted = (
    <div>
      <img src="/static/error-404.svg" alt="404" />
      <p style={STYLE_MT20}>
        {post && (post.deleted_by_admin || post.reason)
          ? `帖子已被管理员删除${post.reason ? `，原因：${post.reason}` : ""}`
          : "帖子已被作者删除"}
      </p>
      <p>
        <Link href="/">
          <Button>返回首页</Button>
        </Link>
      </p>
    </div>
  );

  const pagePrivate = (
    <div>
      <img src="/static/error-404.svg" alt="404" />
      <p style={STYLE_MT20}>此贴已设置为私密贴，仅作者本人可见</p>
      <p>
        <Link href="/">
          <Button>返回首页</Button>
        </Link>
      </p>
    </div>
  );

  const pageHidden = (
    <div>
      <img src="/static/error-404.svg" alt="404" />
      <p style={STYLE_MT20}>
        {post && post.reason
          ? `该贴已被隐藏，隐藏原因：${post.reason}`
          : "该贴已被隐藏"}
      </p>
      <p>
        <Link href="/">
          <Button>返回首页</Button>
        </Link>
      </p>
    </div>
  );

  const page = {
    404: page404,
    deleted: pageDeleted,
    500: page500,
    private: pagePrivate,
    hidden: pageHidden,
  };
  return <div style={STYLE_OUTER}>{page[statusCode] || page[500]}</div>;
};

Page.getInitialProps = async ({ res, err, asPath }) => {
  console.error(`Error in ${asPath}, ${err}`);

  if (res) {
    const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
    return { statusCode };
  }
};

export default Page;
